import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

// The app will now default to Spanish.
// The user can still switch to English from the settings page.
i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: 'es', // Set default language to Spanish
    supportedLngs: ['en', 'es'],
    fallbackLng: 'es', // Fallback to Spanish if a translation is missing
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    ns: ['translation'],
    defaultNS: 'translation',
    react: {
      useSuspense: true,
    },
  });

export default i18n;
